module.exports = __webpack_public_path__ + "static/media/citystay3.6c766016.jpg";